import * as actionTypes from './actionTypes';
import { PackageModel } from '@app/src/views/Package/listPackage/models/PackageModel';

interface State {
  data: PackageModel[];
  isFetching: boolean;
  error: boolean;
  dataPublish: any;
  isFetchingPublish: boolean;
  errorPublish: boolean;
  categorySelected: number;
  packageSelected: number;
  isFetchingConsume: boolean;
  errorConsume: boolean;
  dataConsume: any;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false,
  dataPublish: {},
  isFetchingPublish: false,
  errorPublish: false,
  categorySelected: null,
  packageSelected: null,
  isFetchingConsume: false,
  errorConsume: false,
  dataConsume: {}
}

export const packages = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_PACKAGE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_PACKAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_PACKAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.PUBLISH_PACKAGE_REQUEST:
      return {
        ...state,
        isFetchingPublish: true
      }
    case actionTypes.PUBLISH_PACKAGE_FAILURE:
      return {
        ...state,
        isFetchingPublish: false,
        errorPublish: true
      }
    case actionTypes.PUBLISH_PACKAGE_SUCCESS:
      return {
        ...state,
        isFetchingPublish: false,
        errorPublish: false,
        dataPublish: action.data
      }
    case actionTypes.SET_CATEGORY_PACKAGE:
      return {
        ...state,
        categorySelected: action.id
      }
    case actionTypes.SET_ID_PACKAGE:
      return {
        ...state,
        packageSelected: action.id
      }
    case actionTypes.CLEAR_PUBLISH_PACKAGE_DATA:
      return {
        ...state,
        dataPublish: {}
      }
    case actionTypes.CLEAR_PACKAGE_DATA:
      return {
        ...state,
        data: []
      }
    case actionTypes.CLEAR_PACKAGE_CONSUME_DATA:
      return {
        ...state,
        dataConsume: []
      }
    case actionTypes.FETCH_PACKAGE_CONSUME_REQUEST:
      return {
        ...state,
        isFetchingConsume: true
      }
    case actionTypes.FETCH_PACKAGE_CONSUME_FAILURE:
      return {
        ...state,
        isFetchingConsume: false,
        errorConsume: true
      }
    case actionTypes.FETCH_PACKAGE_CONSUME_SUCCESS:
      return {
        ...state,
        isFetchingConsume: false,
        errorConsume: false,
        dataConsume: action.data
      }
    default:
      return state;
  }
}
